// extracted by mini-css-extract-plugin
export var iconWrapper = "OrderItemInfo-module--iconWrapper--KGspN";
export var noItems = "OrderItemInfo-module--noItems--yOIb8";